import React from 'react';

const POSUserTypePermissionsList = () => (
    <span>
        <p>
            A <strong>POS User Type</strong> defines a permissions level for Users of the POS System. The
            following User Types are available:
        </p>
        <p><em>Super User Permissions</em></p>
        <ul>
            <li>Log into any Location on the POS System</li>
            <li>Start a Regular Audit for a Location</li>
            <li>All Permissions Listed below</li>
        </ul>
        <p><em>District Manager Permissions</em></p>
        <ul>
            <li>Log into Locations assigned to a District</li>
            <li>Start a Regular Audit for a Location</li>
            <li>Product Price Override with ID and PIN</li>
            <li>All Permissions Listed below</li>
        </ul>
        <p><em>Store Manager Permissions</em></p>
        <ul>
            <li>Log into assigned Location</li>
            <li>Tax Removal Override with ID and Pin</li>
            <li>Open/Close Register</li>
            <li>Withdraw Cash from Register</li>
            <li>Create/Edit POS Store/Temp Clerks</li>
            <li>Open Location</li>
            <li>Start Final Audit and Close Location</li>
            <li>Manage Location Inventory</li>
            <li>Reprint Register Close Receipts</li>
            <li>Manage products for Quick Tab (Frequently Purchased Items)</li>
            <li>Full Data Update (Provision) for Register</li>
            <li>Repair Printer Connection</li>
            <li>All Permissions Listed below</li>
        </ul>
        <p><em>Store Clerks and Temp Clerks Permissions</em></p>
        <ul>
            <li>Log into assigned Location</li>
            <li>Recall Last Sale</li>
            <li>Submit products once Audit or Final Audit has started</li>
            <li>Process Sales and Returns</li>
        </ul>
    </span>
);

export default POSUserTypePermissionsList;


// WEBPACK FOOTER //
// ./src/Fuse/components/POSUserTypePermissionsList.js